(function () {
  var STORAGE_KEY = 'atn-zone';
  var STORAGE_TS_KEY = 'atn-zone-ts';
  var ZONE_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days — re-detect periodically

  var GROCERY_BASE = '/collections/grocery';
  var SHIPPING_PARAM = 'gf_509763';
  var SHIPPING_VALUE = '292357996753';

  var LOCAL_POSTAL = ['P8N', 'P9N', 'P8T', 'P0V'];
  var LOCAL_CITIES = [
    'dryden', 'oxdrift', 'wabigoon',
    'kenora', 'keewatin',
    'sioux lookout', 'hudson',
    'vermilion bay', 'dinorwic', 'eagle river'
  ];
  var LOCAL_COORDS = [
    { lat: 49.7764, lng: -92.8375 }, // Dryden
    { lat: 49.7667, lng: -94.4875 }, // Kenora
    { lat: 50.0833, lng: -91.9167 }  // Sioux Lookout
  ];
  var LOCAL_RADIUS_KM = 60;

  function haversine(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLon = (lon2 - lon1) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function isLocal(data) {
    if (data.postal) {
      var prefix = String(data.postal).toUpperCase().substring(0, 3);
      for (var i = 0; i < LOCAL_POSTAL.length; i++) {
        if (prefix === LOCAL_POSTAL[i]) return true;
      }
    }
    if (data.city) {
      var city = String(data.city).toLowerCase();
      for (var j = 0; j < LOCAL_CITIES.length; j++) {
        if (city.indexOf(LOCAL_CITIES[j]) !== -1) return true;
      }
    }
    if (data.latitude && data.longitude) {
      var lat = parseFloat(data.latitude);
      var lng = parseFloat(data.longitude);
      for (var k = 0; k < LOCAL_COORDS.length; k++) {
        if (haversine(lat, lng, LOCAL_COORDS[k].lat, LOCAL_COORDS[k].lng) <= LOCAL_RADIUS_KM) {
          return true;
        }
      }
    }
    return false;
  }

  function isOnGrocery() {
    return window.location.pathname.indexOf(GROCERY_BASE) === 0;
  }

  function isOnShippingFilter() {
    return window.location.pathname === GROCERY_BASE &&
      window.location.search.indexOf(SHIPPING_PARAM) !== -1;
  }

  function isOnBaseGrocery() {
    var path = window.location.pathname;
    return (path === GROCERY_BASE || path === GROCERY_BASE + '/') &&
      window.location.search.indexOf(SHIPPING_PARAM) === -1;
  }

  function applyZone(zone) {
    if (!isOnGrocery()) return;

    if (zone === 'local') {
      if (!isOnShippingFilter()) return;
      var params = new URLSearchParams(window.location.search);
      params.delete(SHIPPING_PARAM);
      var newSearch = params.toString();
      window.location.replace(GROCERY_BASE + (newSearch ? '?' + newSearch : ''));
    } else {
      if (isOnShippingFilter()) return;
      if (!isOnBaseGrocery()) return;
      var params2 = new URLSearchParams(window.location.search);
      params2.set(SHIPPING_PARAM, SHIPPING_VALUE);
      if (!params2.has('sort_by')) params2.set('sort_by', 'price-ascending');
      params2.delete('page');
      window.location.replace(GROCERY_BASE + '?' + params2.toString());
    }
  }

  function saveAndApply(zone) {
    try {
      localStorage.setItem(STORAGE_KEY, zone);
      localStorage.setItem(STORAGE_TS_KEY, String(Date.now()));
    } catch (e) {}
    applyZone(zone);
  }

  function isCacheValid() {
    try {
      var zone = localStorage.getItem(STORAGE_KEY);
      var ts   = localStorage.getItem(STORAGE_TS_KEY);
      if (zone !== 'local' && zone !== 'shipping') return false;
      if (!ts) return false; // legacy cache with no timestamp — force re-detect
      return (Date.now() - parseInt(ts, 10)) < ZONE_TTL_MS;
    } catch (e) { return false; }
  }

  function ipDetect() {
    fetch('https://ipapi.co/json/')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        // ipapi.co returns {error:true, reason:"RateLimited"} when the daily
        // limit is hit — the response still parses as JSON, bypassing .catch().
        // Also guard against empty/malformed responses with no IP field.
        if (data.error || data.reserved || !data.ip) {
          saveAndApply('local');
          return;
        }
        var zone = isLocal(data) ? 'local' : 'shipping';
        saveAndApply(zone);
      })
      .catch(function () {
        // Network failure, CORS block, or non-JSON response → default to local.
        saveAndApply('local');
      });
  }

  // Try GPS first (triggers permission prompt on first visit).
  // On success: save zone and skip IP lookup entirely.
  // On denial/error or absent API: fall through to IP detection.
  function detect() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          var gpsData = { latitude: pos.coords.latitude, longitude: pos.coords.longitude };
          if (window.ATNZone) { window.ATNZone._lastDetectPath = 'gps'; }
          saveAndApply(isLocal(gpsData) ? 'local' : 'shipping');
        },
        function () {
          // GPS denied, timed out, or unavailable — fall through to IP lookup.
          ipDetect();
        },
        { timeout: 5000 }
      );
    } else {
      ipDetect();
    }
  }

  // On a cache hit, silently re-check via GPS if the browser has already
  // granted location permission. When the GPS result disagrees with the
  // cached zone the cache is overwritten and applyZone() is called again
  // (which redirects if on the grocery page). If GPS permission has not
  // been granted this function exits without triggering any prompt.
  function backgroundGpsCheck(cachedZone) {
    if (!navigator.geolocation) return;

    function doGpsCheck() {
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          var gpsData = { latitude: pos.coords.latitude, longitude: pos.coords.longitude };
          var gpsZone = isLocal(gpsData) ? 'local' : 'shipping';
          if (gpsZone !== cachedZone) {
            saveAndApply(gpsZone);
          }
        },
        function () {
          // Error or permission revoked — leave the cache untouched.
        },
        { timeout: 5000, maximumAge: 60000 }
      );
    }

    // Only call getCurrentPosition when permission is already 'granted' so
    // we never trigger the browser's permission prompt silently.
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
        if (result.state === 'granted') {
          doGpsCheck();
        }
      }).catch(function () {
        // permissions API unavailable — skip GPS check.
      });
    }
  }

  function init() {
    if (isCacheValid()) {
      var saved = null;
      try { saved = localStorage.getItem(STORAGE_KEY); } catch (e) {}
      applyZone(saved);
      backgroundGpsCheck(saved);
    } else {
      detect();
    }
  }

  window.ATNZone = {
    _lastDetectPath: null,
    set: function (zone) {
      if (zone !== 'local' && zone !== 'shipping') return;
      saveAndApply(zone);
    },
    get: function () {
      try { return localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
    },
    clear: function () {
      try {
        localStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem(STORAGE_TS_KEY);
      } catch (e) {}
      if (isOnGrocery()) {
        window.location.replace(GROCERY_BASE);
      }
    },
    debug: function () {
      var zone = null, ts = null;
      try { zone = localStorage.getItem(STORAGE_KEY); ts = localStorage.getItem(STORAGE_TS_KEY); } catch(e){}
      var age = ts ? Math.round((Date.now() - parseInt(ts,10)) / 60000) + ' min ago' : 'no timestamp';
      console.log('[ATNZone] zone=' + zone + ' cached=' + age);
      fetch('https://ipapi.co/json/').then(function(r){return r.json();}).then(function(d){
        console.log('[ATNZone] ipapi.co →', d);
        console.log('[ATNZone] isLocal:', window.ATNZone._isLocal(d));
      });
    },
    _isLocal: isLocal
  };

  init();
})();
